document.addEventListener('DOMContentLoaded', () => {
    let sizes = document.querySelectorAll('label[data-option="SIZE"]');
    if (sizes != null){
        sizes.forEach((size) => {
            size.addEventListener('click', () => {
                let variant_size = size.dataset.variant;
                selectColors(variant_size);
            })
        })
        const selectColors = (variant_size) => {
            let colors = document.querySelectorAll('label[data-option="COLOR"');
            colors.forEach((color) => {
                let sizes = color.dataset.sizesAvailable;
                unCheckColor(sizes, variant_size, color);
            })
        }
        const unCheckColor = (sizes, variant_size, color) => {
            if (!sizes.includes("/ "+variant_size)){
                color.classList.add('strikethrough');
                let inputElement = color.previousElementSibling;
                inputElement.checked = false;
            }else{
                color.classList.remove('strikethrough');
            }
        }
    }    
})